const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      color: theme.colors[1],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    intro: {
      background: theme.colors[1],
      color: theme.colors[2],
      paddingTop: 180,
      paddingBottom: 180,
    },
    focusIntro: {
      color: theme.colors[0],
      padding: '40px 0',
      '& > *': {
        display: 'flex',
        flexDirection: 'column',
        gap: 30,
      },
    },
    sectionsTitle: {
      fontFamily: theme.fonts[1],
      fontWeight: 700,
      textTransform: 'uppercase',
      lineHeight: 1.1,
      fontSize: 'calc(15px + 2vw)',
    },
    sectionsText: {
      fontSize: 16,
      lineHeight: 1.5,
      color: theme.getRgba(theme.colors[0], 0.5),
    },
  }

  output[theme.mediaInverse.md] = {
  }

  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
